var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mydg-right-content"},[_c('div',{staticClass:"mydg-right-content-wrapper"},[_c('div',{staticClass:"dgd-it-dashboard-thumbnail"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.getImageUrl(_vm.block.payload.it_policy_image_url)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }